import { c as _c } from "react/compiler-runtime";
import { Button, Separator, HStack, IconButton, Link, Text, VStack, Field } from '@chakra-ui/react';
import { AutoResizeTextarea } from '@src/components/sco/AutoResizeTextarea';
import { HelpModal } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/HelpModal';
import { PitchBuidlerFormProps } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/index';
import React, { useEffect } from 'react';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu';
export const PitchSection: React.FC<PitchBuidlerFormProps> = props => {
  const $ = _c(66);
  const [showHelpModal, setShowHelpModal] = React.useState(false);
  const [sectionIndex, setSectionIndex] = React.useState(0);
  const [problemStatement, setProblemStatement] = React.useState(props.investorSearch.problemStatement || "");
  const [solutionStatement, setSolutionStatement] = React.useState(props.investorSearch.problemStatement || "");
  const [marketSizeStatement, setMarketSizeStatement] = React.useState(props.investorSearch.problemStatement || "");
  let t0;
  let t1;
  if ($[0] !== props.investorSearch.marketSizeStatement || $[1] !== props.investorSearch.problemStatement || $[2] !== props.investorSearch.solutionStatement) {
    t0 = () => {
      setProblemStatement(props.investorSearch.problemStatement || "");
      setSolutionStatement(props.investorSearch.solutionStatement || "");
      setMarketSizeStatement(props.investorSearch.marketSizeStatement || "");
    };
    t1 = [props.investorSearch.problemStatement, props.investorSearch.solutionStatement, props.investorSearch.marketSizeStatement];
    $[0] = props.investorSearch.marketSizeStatement;
    $[1] = props.investorSearch.problemStatement;
    $[2] = props.investorSearch.solutionStatement;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== marketSizeStatement || $[6] !== problemStatement || $[7] !== props || $[8] !== solutionStatement) {
    t2 = async t3 => {
      const next = t3 === undefined ? _temp : t3;
      if (!props.investorSearch.investorSearchId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertInvestorSearch({
        variables: {
          input: {
            investorSearchId: props.investorSearch.investorSearchId,
            problemStatement,
            solutionStatement,
            marketSizeStatement
          }
        }
      });
      if (next) {
        next();
      }
    };
    $[5] = marketSizeStatement;
    $[6] = problemStatement;
    $[7] = props;
    $[8] = solutionStatement;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const performSave = t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [{
      key: "problemStatement",
      title: "Problem",
      description: "What is the key problem you are solving?",
      label: "Problem Statement"
    }, {
      key: "solutionStatement",
      title: "Solution",
      description: "What is the solution your startup offers?",
      label: "Solution Statement"
    }, {
      key: "marketSizeStatement",
      title: "Market Size",
      description: "How big is the market you are targeting?",
      label: "Market Size"
    }];
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const sections = t3;
  const activeSection = sections[sectionIndex];
  let t4;
  if ($[11] !== marketSizeStatement || $[12] !== problemStatement || $[13] !== solutionStatement) {
    t4 = {
      problemStatement,
      solutionStatement,
      marketSizeStatement
    };
    $[11] = marketSizeStatement;
    $[12] = problemStatement;
    $[13] = solutionStatement;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const values = t4;
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      set_problemStatement: setProblemStatement,
      set_solutionStatement: setSolutionStatement,
      set_marketSizeStatement: setMarketSizeStatement
    };
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const setters = t5;
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== activeSection.description) {
    t7 = activeSection.description && <Text color="white" fontSize="12px">{activeSection.description}</Text>;
    $[17] = activeSection.description;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== activeSection.label || $[20] !== t7) {
    t8 = <Field.Label>{activeSection.label}{t6}{t7}</Field.Label>;
    $[19] = activeSection.label;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Button size="xs" variant="outline" onClick={() => setShowHelpModal(true)}>Need Help?</Button>;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8) {
    t10 = <HStack align="flex-start" justify="space-between" marginBottom={1}>{t8}{t9}</HStack>;
    $[23] = t8;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = values[activeSection.key];
  let t12;
  if ($[25] !== performSave) {
    t12 = () => performSave();
    $[25] = performSave;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== activeSection.key) {
    t13 = ev => {
      const setter = setters[`set_${activeSection.key}`];
      if (setter) {
        setter(ev.target.value);
      }
    };
    $[27] = activeSection.key;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t13) {
    t14 = <AutoResizeTextarea minHeight="100px" value={t11} onBlur={t12} onChange={t13} />;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t10 || $[34] !== t14) {
    t15 = <Field.Root>{t10}{t14}</Field.Root>;
    $[33] = t10;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== performSave || $[37] !== props || $[38] !== sectionIndex) {
    t16 = <HStack justify="flex-end" paddingY={2} width="full"><Button size="xs" variant="cta" onClick={async () => {
        await performSave();
        if (sectionIndex < sections.length - 1) {
          setSectionIndex(sectionIndex + 1);
        } else {
          props.onNextSection?.();
        }
      }}>{"Save & Continue"}</Button></HStack>;
    $[36] = performSave;
    $[37] = props;
    $[38] = sectionIndex;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t15 || $[41] !== t16) {
    t17 = <VStack align="stretch" gap={2} padding={4}>{t15}{t16}</VStack>;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Separator />;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== sectionIndex) {
    t19 = () => {
      setSectionIndex(sectionIndex - 1);
    };
    $[44] = sectionIndex;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <LuChevronLeft size={16} />;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t19) {
    t21 = <IconButton aria-label="Prev" size="xs" variant="outlineGhost" onClick={t19}>{t20}</IconButton>;
    $[47] = t19;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== sectionIndex) {
    t22 = <HStack flexGrow={1} gap={4} justify="center">{sections.map((subsection, idx) => <Link key={subsection.key} color={idx == sectionIndex ? "white" : "whiteAlpha.600"} fontFamily="Poppins" onClick={() => setSectionIndex(idx)} fontSize="sm" fontWeight="bold">{subsection.title}</Link>)}</HStack>;
    $[49] = sectionIndex;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== sectionIndex) {
    t23 = () => {
      setSectionIndex(sectionIndex + 1);
    };
    $[51] = sectionIndex;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <LuChevronRight size={16} />;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t23) {
    t25 = <IconButton aria-label="Next" size="xs" variant="outlineGhost" onClick={t23}>{t24}</IconButton>;
    $[54] = t23;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t21 || $[57] !== t22 || $[58] !== t25) {
    t26 = <HStack padding={4}>{t21}{t22}{t25}</HStack>;
    $[56] = t21;
    $[57] = t22;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== showHelpModal) {
    t27 = <HelpModal setShowHelpModal={setShowHelpModal} showHelpModal={showHelpModal} />;
    $[60] = showHelpModal;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t17 || $[63] !== t26 || $[64] !== t27) {
    t28 = <>{t17}{t18}{t26}{t27}</>;
    $[62] = t17;
    $[63] = t26;
    $[64] = t27;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  return t28;
};
function _temp() {}